export default __webpack_public_path__ + "static/media/wd.3a14880e.svg";